import React from "react";
import { StatusDot } from "./StatusVisuals";
import { THRESHOLDS, evaluateTone, toneHex } from "../utils/statusSemantics";

const isNil = (value) => value === null || value === undefined;

const fmtNum = (value) => {
    if (isNil(value) || Number.isNaN(Number(value))) return "--";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 });
};

const fmtPct = (value) => {
    if (isNil(value) || Number.isNaN(Number(value))) return "--";
    return `${(Number(value) * 100).toFixed(1)}%`;
};

/**
 * 客户履约红黄绿矩阵（规划 10.3）。
 * 每个客户一张卡，履约率按阈值红黄绿着色，整卡可点击下钻。
 */
export function CustomerMatrix({ customers = [], onSelect }) {
    return (
        <div className="business-dashboard-customer-grid">
            {customers.map((customer) => {
                const tone = evaluateTone(customer.fulfillment_rate, THRESHOLDS.customerFulfillment);
                const name = customer.customer_name || customer.customer_id;
                return (
                    <button
                        type="button"
                        key={customer.customer_id}
                        className={`business-dashboard-cust-card business-dashboard-cust-card--${tone}`}
                        onClick={() => onSelect?.(customer)}
                    >
                        <div className="business-dashboard-cust-head">
                            <span className="business-dashboard-cust-name" title={name}>{name}</span>
                            <StatusDot tone={tone} size={9} />
                        </div>
                        <div className="business-dashboard-cust-rate" style={{ color: toneHex(tone) }}>
                            {fmtPct(customer.fulfillment_rate)}
                        </div>
                        <div className="business-dashboard-cust-rate-label">履约率</div>
                        <div className="business-dashboard-cust-foot">
                            <span>计划/实际 {fmtNum(customer.planned_commercial_flights)} / {fmtNum(customer.actual_commercial_flights)}</span>
                            <span>取消率 {fmtPct(customer.customer_cancel_rate)}</span>
                            <span>BH 占比 {fmtPct(customer.customer_bh_share)}</span>
                        </div>
                    </button>
                );
            })}
        </div>
    );
}
